<template>
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_20408_8562)">
      <path
        d="M7.14213 2.51626C7.34506 2.31327 7.58599 2.15224 7.85117 2.04238C8.11634 1.93252 8.40056 1.87598 8.68759 1.87598C8.97463 1.87598 9.25885 1.93252 9.52402 2.04238C9.78919 2.15224 10.0301 2.31327 10.2331 2.51626C10.4361 2.71919 10.5971 2.96013 10.7069 3.2253C10.8168 3.49048 10.8733 3.7747 10.8733 4.06173C10.8733 4.34876 10.8168 4.63298 10.7069 4.89815C10.5971 5.16333 10.4361 5.40426 10.2331 5.6072L9.09025 6.75001L8.60556 7.2347C8.40239 7.4379 8.16115 7.59905 7.89564 7.70892C7.63012 7.8188 7.34555 7.87524 7.0582 7.87502C6.77085 7.8748 6.48637 7.81793 6.22102 7.70765C5.95567 7.59738 5.71467 7.43586 5.51181 7.23235C5.30183 7.02245 5.13697 6.77185 5.02734 6.49593"
        stroke="#868D9C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.85626 9.48372C4.65309 9.68692 4.41185 9.84807 4.14634 9.95795C3.88082 10.0678 3.59625 10.1243 3.3089 10.124C3.02155 10.1238 2.73707 10.067 2.47172 9.95668C2.20637 9.8464 1.96537 9.68489 1.76251 9.48138C1.35376 9.0712 1.12447 8.51557 1.125 7.9365C1.12553 7.35742 1.35582 6.80222 1.76533 6.39278L3.39283 4.76528C3.59576 4.56229 3.83669 4.40127 4.10187 4.29141C4.36704 4.18155 4.65126 4.125 4.93829 4.125C5.22533 4.125 5.50955 4.18155 5.77472 4.29141C6.03989 4.40127 6.28083 4.56229 6.48376 4.76528C6.69461 4.97517 6.86021 5.22604 6.97033 5.50241"
        stroke="#868D9C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_20408_8562">
        <rect width="12" height="12" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
